<template>
	<div class="review">
		<div class="view-title">
			<translate>Application</translate>
		</div>
		<el-tabs type="card" class="teamTab" :active-name="initTabName" @tab-click="onTabClick">
			<!--sql审核-->
			<el-tab-pane name="sql" :label="attrText.sql">
				<el-tabs class="reviewTab" :active-name="sqlActiveName" @tab-click="sqlTabClick">
					<!-- sql发起申请 -->
					<!-- <el-tab-pane :label="attrText.startApplication" name="sqlApply" v-if="initTabName === 'sql'">
            <div class="tab-content">
              <el-form ref="sqlForm" :model="m" :rules="sqlRules" class="apply-form" label-width="80px">
                <el-form-item :label="attrText.project" prop="project_id" v-if="projectList">
                  <div class="review-select-box">
                    <el-select class="review-select" v-model="m.project_id" @change="projectChanged(m.project_id)">
                      <el-option :label="attrText.select" value=""></el-option>
                      <el-option v-for="(option, index) in projectList" :label="option.project_name" :key="index" :value="option.id"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="attrText.resource" prop="resourceIndex" v-if="resourceList" >
                  <div class="review-select-box">
                    <el-select class="review-select"  v-model="m.resourceIndex" @change="sqlResourceChanged(m.resourceIndex)">
                      <el-option :label="attrText.select" value=""></el-option>
                      <el-option v-for="(resource,index) in resourceList[m.project_id]" :key="index" :label="resource.resource.name" :value="index"></el-option>
                    </el-select>
                  </div>
                  <div class="font-danger">
                    <span class="font-danger" v-if="m.resource.resource  && m.resource.resource.status!=2"><translate>Please select the resource that has opened the SQL application</translate></span>
                  </div>
                </el-form-item>
                <el-form-item label="SQL" prop="sql">
                  <el-input type="textarea" v-model="m.sql"></el-input>
                </el-form-item>
                <el-form-item :label="attrText.comment" prop="comment">
                  <el-input type="textarea" v-model="m.comment" width="360px"></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <el-button type="primary" @click="sqlApplySubmit('sqlForm')" ><translate>Submit</translate></el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane> -->
					<!--sql 待审核的-->
					<el-tab-pane :label="attrText.pendingApplication" name="sqlWaitApprove">
						<el-table v-loading="waitSqlApplication.loading" class="apply-table" :data="waitSqlApplication.list" @row-click="viewApprovingSqlApply" style="width: 100%" stripe>
							<el-table-column :label="attrText.applyer">
								<template scope="scope">
									<img class="apply-avatar" v-if="scope.row.account" :src="scope.row.account.avatar | resetURL" border="0" />
									<div class="apply-avatar-name" v-if="scope.row.account">{{ scope.row.account.name }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.resource">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
									<div v-if="scope.row.project" class="limit-text">{{ scope.row.project.project_name ? scope.row.project.project_name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.targetDatabase">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.database ? scope.row.database : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.general">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.comment }}</div>
									<div class="limit-text">{{ scope.row.sql }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.createTime" width="180">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="waitSqlApplication.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="waitSqlApplication.totalPage" :page-size="10" :current-page.sync="waitSqlApplication.currentPage" @current-change="waitSqlApplicationChangePage"></el-pagination>
						</div>
					</el-tab-pane>
					<!--sql 已审核的-->
					<el-tab-pane :label="attrText.myApproved" name="sqlApproved">
						<el-table v-loading="approvedSqlApplication.loading" class="apply-table" :data="approvedSqlApplication.list" @row-click="viewApprovedSql" style="width: 100%" stripe>
							<el-table-column :label="attrText.applyer">
								<template scope="scope">
									<img class="apply-avatar" v-if="scope.row.account" :src="scope.row.account.avatar | resetURL" border="0" />
									<div class="apply-avatar-name" v-if="scope.row.account">{{ scope.row.account.name }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.resource">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
									<div class="limit-text" v-if="scope.row.project">{{ scope.row.project.project_name ? scope.row.project.project_name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.targetDatabase">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.database ? scope.row.database : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.general">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.comment }}</div>
									<div class="limit-text">{{ scope.row.sql }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.createTime" width="180">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.status" width="80">
								<template scope="scope">
									<span :class="applyStatus[scope.row.status]">{{ sqlApplyStatusText[scope.row.status] }}</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="approvedSqlApplication.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="approvedSqlApplication.totalPage" :page-size="10" :current-page.sync="approvedSqlApplication.currentPage" @current-change="approvedSqlApplicationChangePage"></el-pagination>
						</div>
					</el-tab-pane>
					<!--sql 我发起的-->
					<el-tab-pane :label="attrText.myApplication" name="sqlMyApply">
						<el-table v-loading="mySqlApplication.loading" class="apply-table" :data="mySqlApplication.list" @row-click="viewMySqlApply" style="width: 100%" stripe>
							<el-table-column :label="attrText.resourceName">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.targetDatabase">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.database ? scope.row.database : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.general">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.comment }}</div>
									<div class="limit-text">{{ scope.row.sql }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.createTime">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.updateTime" width="180">
								<template scope="scope">
									{{ (scope.row.update_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.status" width="80">
								<template scope="scope">
									<span :class="applyStatus[scope.row.status]">{{ sqlApplyStatusText[scope.row.status] }}</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="mySqlApplication.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="mySqlApplication.totalPage" :page-size="10" :current-page.sync="mySqlApplication.currentPage" @current-change="onMySqlChangePage"></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-tab-pane>

			<!--安全模式-->
			<el-tab-pane name="safe" :label="attrText.safeMode">
				<el-tabs class="reviewTab" :active-name="safeActiveName" @tab-click="safeTabClick">
					<!-- 安全模式发起申请 -->
					<!-- <el-tab-pane :label="attrText.startApplication" name="safeApply" v-if="initTabName === 'safe'">
            <el-form ref="safeForm" :model="safe" :rules="safeRules" class="apply-form" label-width="150px">
                <el-form-item :label="attrText.project" prop="project">
                  <div class="review-select-box">
                    <el-select class="review-select"  v-model="safe.project" @change="safeChanged(safe.project)">
                      <el-option :label="attrText.select" value=""></el-option>
                      <el-option v-for="(option,index) in safeApplyList.projectList" :key="index" :label="option" :value="option"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="attrText.resourceName" prop="resourceIndex" >
                  <div class="review-select-box" >
                    <el-select class="review-select"  v-model="safe.resourceIndex" @change="safeResourceChange(safe.resourceIndex)">
                      <el-option :label="attrText.select" value=" "></el-option>
                      <el-option v-for="(resource,index) in safeApplyList.resourceList[safe.project]" :key="index" :label="resource.resource.name" :value="index"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item :label="attrText.reason" prop="reason">
                  <el-input type="textarea" v-model="safe.reason"></el-input>
                </el-form-item>
                <el-form-item :label="attrText.validTime" prop="time">
                   <el-date-picker
                    v-model="safe.time"
                    type="datetime"
                    class="safe-datetime-picker"
                    :picker-options="safeOptions"
                    :placeholder="attrText.selectDate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label=" ">
                  <el-button type="primary" @click="safeApplySubmit('safeForm')"><translate>Submit</translate></el-button>
                </el-form-item>
              </el-form>
          </el-tab-pane> -->
					<!-- 安全模式待审批的 -->
					<el-tab-pane :label="attrText.pendingApplication" name="safeWaitApprove">
						<el-table v-loading="safeApprovingList.loading" class="apply-table" :data="safeApprovingList.list" @row-click="viewApprovingSafe" style="width: 100%" stripe>
							<el-table-column :label="attrText.applyer">
								<template scope="scope">
									<img class="apply-avatar" v-if="scope.row.account" :src="scope.row.account.avatar | resetURL" border="0" />
									<div class="apply-avatar-name" v-if="scope.row.account">{{ scope.row.account.name }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.resourceName">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
									<div class="limit-text" v-if="scope.row.project">{{ scope.row.project.project_name ? scope.row.project.project_name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.general">
								<template scope="scope">
									{{ scope.row.reason }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.updateTime" width="180">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.status" width="80">
								<template scope="scope">
									<span :class="applyStatus[scope.row.app_status]">{{ safeApplyStatusText[scope.row.app_status] }}</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="safeApprovingList.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="safeApprovingList.totalPage" :page-size="10" :current-page.sync="safeApprovingList.currentPage" @current-change="safeApprovingChangePage"></el-pagination>
						</div>
					</el-tab-pane>
					<!-- 安全模式待审批的 -->
					<el-tab-pane :label="attrText.myApproved" name="safeApproved">
						<el-table v-loading="safeApprovedList.loading" class="apply-table" :data="safeApprovedList.list" @row-click="viewApprovedSafe" style="width: 100%" stripe>
							<el-table-column :label="attrText.applyer">
								<template scope="scope">
									<img class="apply-avatar" v-if="scope.row.account" :src="scope.row.account.avatar | resetURL" border="0" />
									<div class="apply-avatar-name" v-if="scope.row.account">{{ scope.row.account.name }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.resourceName">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
									<div class="limit-text" v-if="scope.row.project">{{ scope.row.project.project_name ? scope.row.project.project_name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.general">
								<template scope="scope">
									{{ scope.row.reason }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.updateTime" width="180">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.status" width="80">
								<template scope="scope">
									<span :class="applyStatus[scope.row.app_status]">{{ safeApplyStatusText[scope.row.app_status] }}</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="safeApprovedList.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="safeApprovedList.totalPage" :page-size="10" :current-page.sync="safeApprovedList.currentPage" @current-change="safeApprovedChangePage"></el-pagination>
						</div>
					</el-tab-pane>
					<!-- 安全模式我发起的 -->
					<el-tab-pane :label="attrText.myApplication" name="safeMyApply">
						<el-table v-loading="mySafeApplyList.loading" class="apply-table" :data="mySafeApplyList.list" @row-click="viewMySafeApply" style="width: 100%" stripe>
							<el-table-column :label="attrText.resource" prop="resource.name">
								<template scope="scope">
									<div class="limit-text">{{ scope.row.resource ? scope.row.resource.name : '-' }}</div>
									<div class="limit-text" v-if="scope.row.project">{{ scope.row.project.project_name ? scope.row.project.project_name : '-' }}</div>
								</template>
							</el-table-column>
							<el-table-column :label="attrText.effectiveTime">
								<template scope="scope">
									{{ (scope.row.expire_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.createTime">
								<template scope="scope">
									{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.updateTime">
								<template scope="scope">
									{{ (scope.row.update_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
								</template>
							</el-table-column>
							<el-table-column :label="attrText.status" width="80">
								<template scope="scope">
									<span :class="applyStatus[scope.row.app_status]">{{ safeApplyStatusText[scope.row.app_status] }}</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination" v-if="mySafeApplyList.totalPage > 1">
							<el-pagination layout="prev, pager, next" :page-count="mySafeApplyList.totalPage" :page-size="10" :current-page.sync="mySafeApplyList.currentPage" @current-change="onMySafeChangePage"></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-tab-pane>
		</el-tabs>
		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @onShowModal="onShowModal" @viewCallback="viewCallback"></component>
		<!--<my-sql-view ref="mySqlView" v-on:getMySqlList="_getMySqlApplication" v-on:sqlChangeToApproved="sqlChangeToApproved"></my-sql-view>-->
		<!--<safe-view ref="safeView" v-on:getMySafeModeApplication="getMySafeModeApplication" v-on:safeChangToApproved="safeChangToApproved"></safe-view>-->

		<!-- 弹窗 -->
		<!-- 预览SQL -->
		<el-dialog :title="attrText.previewSQL" :visible.sync="showModal.previewSQL">
			<CodemirrorEditor v-if="showModal.previewSQL" ref="codemirrorEditor" @input="onEditorInput" :value="previewSQL" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showModal.previewSQL = false">
					<translate>Confirm</translate>
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import STORE_CONST from '../../store/consts'
import { Utils } from '../../config'
import mySqlView from './model/mySqlView'
import safeView from './model/safeView'
import Utility from '../../Utils'
import CodemirrorEditor from './model/code-mirror-editor.vue'
export default {
	data() {
		return {
			previewSQL: '',
			resourceType: 'rds',
			resourceList: [],
			projectList: [],
			networkList: null,
			initTabName: 'sql',
			projectResourceId: null,
			tabType: this.$route.query.type,
			initInfo: {
				init: true,
			},
			initResource: false,
			sqlActiveName: 'sqlWaitApprove',
			safeActiveName: 'safeWaitApprove',
			account: this.$store.getters.account,
			m: {
				btnDisabled: false,
				project: '',
				resource: '',
				sql: '',
				comment: '',
				project_id: null,
				resource_id: null,
				resourceIndex: null,
			},
			safe: {
				btnDisabled: false,
				project: '',
				resource: '',
				reason: '',
				time: '',
				resource_id: null,
				resourceIndex: null,
			},
			mySqlApplication: {
				loading: true,
				list: [],
				totalPage: 0,
				pageSize: 10,
				currentPage: 1,
			},
			waitSqlApplication: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			approvedSqlApplication: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			safeApplyList: {
				projectList: [],
				resourceList: [],
			},
			mySafeApplyList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			safeApprovingList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			safeApprovedList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1,
			},
			safeOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now()
				},
			},
			sqlApplyStatusText: {
				approving: this.$gettext('approving'),
				approve_wait_result: this.$gettext('approved'),
				rejected: this.$gettext('rejected'),
				approved: this.$gettext('success'),
				failed: this.$gettext('failed'),
			},
			safeApplyStatusText: {
				0: this.$gettext('approving'),
				1: this.$gettext('approved'),
				2: this.$gettext('rejected'),
				3: this.$gettext('failed'),
			},
			applyStatus: {
				approve_wait_result: 'approved',
				rejected: 'rejected',
				failed: 'failed',
				1: 'approved',
				2: 'rejected',
				3: 'failed',
			},
			sqlRules: {
				project_id: [{ required: true, type: 'number', message: this.$gettext('Please select workgroup'), trigger: 'blur' }],
				resourceIndex: [{ required: true, type: 'number', message: this.$gettext('Please select resource'), trigger: 'blur' }],
				sql: [{ required: true, message: this.$gettext('Please input sql'), trigger: 'blur' }],
				comment: [{ required: true, message: this.$gettext('Please input comment'), trigger: 'blur' }],
			},
			safeRules: {
				project: [{ required: true, message: this.$gettext('Please select workgroup'), trigger: 'blur' }],
				resourceIndex: [{ required: true, type: 'number', message: this.$gettext('Please select resource'), trigger: 'blur' }],
				reason: [{ required: true, message: this.$gettext('Please input applicate reason'), trigger: 'blur' }],
				time: [{ required: true, type: 'date', message: this.$gettext('Please select date'), trigger: 'blur' }],
			},
			currentRightPanel: null,
			rightPanelData: null,
			showModal: {
				previewSQL: false,
			},
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
		getAccount() {
			return this.$store.getters.account
		},
	},
	created() {
		console.log('created')
		this.initTab()
		// this.getNetworkList()
		// this.getProjectList()
		// this.getSafeModeApplication()
	},
	methods: {
		initAttrText() {
			return {
				sql: this.$gettext('SQL Application'),
				safeMode: this.$gettext('Security Mode'),
				project: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				comment: this.$gettext('Comment'),
				resourceName: this.$gettext('Resource Name'),
				reason: this.$gettext('The Reasons For The Application'),
				validTime: this.$gettext('Valid Time'),
				startApplication: this.$gettext('Start Application'),
				select: this.$gettext('select'),
				myApplication: this.$gettext('My Application'),
				general: this.$gettext('General'),
				createTime: this.$gettext('Created Time'),
				applyer: this.$gettext('Applyer'),
				pendingApplication: this.$gettext('Pending Application'),
				myApproved: this.$gettext('My Approved'),
				status: this.$gettext('Status'),
				updateTime: this.$gettext('Update Time'),
				selectDate: this.$gettext('Please Select Date'),
				effectiveTime: this.$gettext('Valid Time'),
				targetDatabase: this.$gettext('Target Database'),
				previewSQL: this.$gettext('Preview SQL'),
			}
		},
		onEditorInput(code) {
			// 编辑器输入事件
			this.previewSQL = code
		},
		onShowModal(params) {
			this.showModal[params.name] = true
			if (params.name === 'previewSQL') {
				this.previewSQL = params.data.sql
			}
		},
		initTab() {
			if (this.$route.query.id) {
				this.projectResourceId = this.$route.query.id.toString()
			}
			if (this.projectResourceId && this.projectResourceId.indexOf('-')) {
				let index = this.projectResourceId.indexOf('-')
				this.initInfo.projectResourceId = this.projectResourceId.substring(0, index)
				this.initInfo.projectName = this.projectResourceId.substring(index + 1)
				console.log('initInfo', this.initInfo)
			}
			if (this.$route.query.type === 'sql') {
				this.initTabName = this.$route.query.type
				// this.getProjectList()
				this.sqlWaitApplication(1)
			} else if (this.$route.query.type === 'safe') {
				this.initTabName = this.$route.query.type
				// this.getSafeModeApplication()
				this.getSafeApprovingApplication(1)
			} else {
				this.initTabName = 'sql'
				this.onTabClick({ name: 'sql' })
			}
		},
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		resetForm(formName) {
			if (this.$refs[formName]) {
				this.$refs[formName].resetFields()
			}
		},
		onTabClick(tab) {
			this.initTabName = tab.name
			if (tab.name === 'sql') {
				// load setting data
				// this.resetForm('sqlForm')
				this.$router.replace({ name: 'operation.review', query: { type: 'sql' } })
				// this.getProjectList()
			} else {
				// load team list data
				// this.resetForm('safeForm')
				this.$router.replace({ name: 'operation.review', query: { type: 'safe' } })
				// this.getSafeModeApplication()
			}
		},
		sqlTabClick(tab) {
			if (tab.name === 'sqlApply') {
				this.sqlActiveName = 'sqlApply'
				this.resetForm('sqlForm')
				this.getProjectList()
			} else if (tab.name === 'sqlWaitApprove') {
				this.sqlActiveName = 'sqlWaitApprove'
				this.sqlWaitApplication(1)
			} else if (tab.name === 'sqlApproved') {
				this.sqlActiveName = 'sqlApproved'
				this.sqlApprovedApplication(1)
			} else if (tab.name === 'sqlMyApply') {
				this.sqlActiveName = 'sqlMyApply'
				this._getMySqlApplication()
			}
		},
		safeTabClick(tab) {
			if (tab.name === 'safeApply') {
				this.safeActiveName = 'safeApply'
				this.resetForm('safeForm')
				this.getSafeModeApplication()
			} else if (tab.name === 'safeWaitApprove') {
				this.safeActiveName = 'safeWaitApprove'
				this.getSafeApprovingApplication(1)
			} else if (tab.name === 'safeApproved') {
				this.safeActiveName = 'safeApproved'
				this.getSafeApprovedApplication(1)
			} else if (tab.name === 'safeMyApply') {
				this.safeActiveName = 'safeMyApply'
				this.getMySafeModeApplication(1)
			}
		},
		sqlApplySubmit(sqlForm) {
			this.m.btnDisabled = true
			this.$refs[sqlForm].validate((valid) => {
				if (valid && this.m.resource && this.m.resource.resource.status === 2) {
					const params = {
						project_resource_id: this.m.resource.id,
						sql: this.m.sql,
						comment: this.m.comment,
					}
					this.$store.dispatch(STORE_CONST.REVIEW.CREATE_SQL_APPLICATION, params).then((res) => {
						this.m.btnDisabled = true
						this.sqlActiveName = 'sqlMyApply'
						this._getMySqlApplication(1)
						this.$notify({
							type: 'success',
							message: this.$gettext('Create successfully!'),
						})
					})
				} else {
					this.m.btnDisabled = false
					return false
				}
			})
		},
		safeApplySubmit(safeForm) {
			this.safe.btnDisabled = true
			this.$refs[safeForm].validate((valid) => {
				if (valid) {
					const params = {
						project_id: this.safe.resource.project_resource.project_id,
						project_resource_id: this.safe.resource.project_resource.id,
						reason: this.safe.reason,
						expire_time: Date.parse(this.safe.time) / 1000,
					}
					this.$store.dispatch(STORE_CONST.REVIEW.CREATE_SAFE_APPLY, params).then((res) => {
						this.safe.btnDisabled = true
						this.safeActiveName = 'safeMyApply'
						this.getMySafeModeApplication(1)
						this.$notify({
							type: 'success',
							message: this.$gettext('Create successfully!'),
						})
					})
				} else {
					this.safe.btnDisabled = false
					return false
				}
			})
		},
		getProjectList() {
			let ids = []
			let networkIds = []
			const params = {
				results_per_page: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_PROJECT_LIST, params).then((res) => {
				if (res.objects && res.objects.length) {
					this.projectList = res.objects
					console.log('projectList', this.projectList)
					this.projectList.forEach((item) => {
						ids.push(item.id)
						networkIds.push()
						if (this.initInfo.projectResourceId && this.initInfo.projectName) {
							if (+this.initInfo.projectName === item.id) {
								this.initInfo.projectRealName = item.project_name
								this.m.project = item
							}
						}
					})
					if (!this.initInfo.projectResourceId) {
						this.m.project = this.projectList[0]
					}
					this.m.project_id = this.m.project.id
					this.getResourceList(ids)
				}
			})
		},
		getResourceList(ids) {
			const params = {
				results_per_page: Utils.config.maxPageSize,
				q: {
					filters: [
						{
							name: 'project_id',
							op: 'in',
							val: ids,
						},
						{
							name: 'resource__resource_type',
							op: 'has',
							val: this.resourceType,
						},
					],
					order_by: [
						{
							field: 'create_time',
							direction: 'desc',
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_RESOURCE_LIST, params).then((res) => {
				if (res.objects && res.objects.length) {
					this.resourceList = res.objects.groupBy('project_id')
					console.log('resourceList', this.resourceList)
					this.initResource = true
					// 拿network——id请求network接口拿版本信息
					if (this.initInfo.projectResourceId && this.initInfo.projectName) {
						this.resourceList[this.initInfo.projectName].forEach((item, index) => {
							if (+this.initInfo.projectResourceId === item.id) {
								console.log('item ===> ', item)
								this.m.resource = item
								this.m.resource_id = this.m.resource.id
								this.m.resourceIndex = index
							}
							// 新版sql不支持审批拿agent版本
							// if (this.networkList && this.resourceList[item.project_id].length) {
							//   this.resourceList[item.project_id].forEach((listItem, index) => {
							//     if (listItem.resource && listItem.resource.network_id) {
							//       this.m.resource.agentVersion = Utility.Utils.getAgentVersion(this.networkList[item.resource.network_id][0].agent.version)
							//     }
							//   })
							//   console.log('resource-changed->list', this.m.agentVersion, this.resourceList[item.project_id])
							// } else {
							//   this.getNetworkList(1, (networkList) => {
							//     this.resourceList[item.project_id].forEach((listItem, index) => {
							//       if (listItem.resource && listItem.resource.network_id) {
							//         this.m.resource.agentVersion = Utility.Utils.getAgentVersion(networkList[item.resource.network_id][0].agent.version)
							//       }
							//     })
							//     console.log('resource-changed->list', this.resourceList[item.project_id])
							//   })
							// }
						})
						console.log('resourceList===>', this.m.resource, this.resourceList)
					} else {
						this.projectChanged(this.m.project.id)
					}
				}
			})
		},
		getNetworkList(page, cb) {
			let params = {
				params: {
					page: page || 1,
					results_per_page: 65535,
					q: { order_by: [{ field: 'create_time', direction: 'desc' }] },
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET, params).then((res) => {
				if (res.objects.length) {
					this.networkList = res.objects.groupBy('id')
					if (cb) {
						cb(this.networkList)
					}
					console.log('this.networkList', this.networkList)
				}
			})
		},
		projectChanged(id) {
			// console.log('change-->', id, this.resourceList)
			if (id && this.resourceList[id]) {
				this.m.resource = this.resourceList[id][0]
				this.m.project_id = id
				console.log('this.m.resource-->', this.m.resource)
				this.m.resource_id = this.m.resource.id
				this.m.resourceIndex = 0
				// 新版sql不支持审批拿agent版本
				if (this.networkList && this.resourceList[id].length) {
					this.resourceList[id].forEach((item, index) => {
						if (item.resource && item.resource.network_id) {
							item.agentVersion = Utility.Utils.getAgentVersion(this.networkList[item.resource.network_id][0].agent.version)
						}
					})
					console.log('resource-changed->list', this.resourceList[id], this.resourceList)
				} else {
					this.getNetworkList(1, (networkList) => {
						this.resourceList[id].forEach((item, index) => {
							if (item.resource && item.resource.network_id) {
								item.angentVersion = Utility.Utils.getAgentVersion(networkList[item.resource.network_id][0].agent.version)
							}
						})
						console.log('resource-changed->list', this.resourceList[id])
					})
				}
			} else {
				this.m.resource = ''
				this.m.resource_id = null
				this.m.resourceIndex = ''
			}
		},
		sqlResourceChanged(index) {
			// console.log('index', typeof (index), this.m.resourceIndex, index)
			if (typeof index === 'number') {
				this.m.resource = this.resourceList[this.m.project_id][index]
				this.m.resource_id = this.m.resource.resource_id
			}
			console.log('index', this.m.resource)
		},
		_getMySqlApplication(page) {
			this.mySqlApplication.list = []
			const params = {
				results_per_page: 10,
				page: page || 1,
				q: {
					order_by: [
						{
							field: 'create_time',
							direction: 'desc',
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_MY_SQL_APPLICATION, params).then(
				(res) => {
					this.mySqlApplication.loading = false
					this.mySqlApplication.list = res.objects
					this.mySqlApplication.totalPage = res.total_pages
					this.mySqlApplication.currentPage = res.page
				},
				() => {
					this.mySqlApplication.loading = false
				}
			)
		},
		onMySqlChangePage(page) {
			this._getMySqlApplication(page)
		},
		sqlWaitApplication(page) {
			const params = {
				results_per_page: 10,
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_SQL_APPROVING_APPLICATION, params).then(
				(res) => {
					this.waitSqlApplication.loading = false
					this.waitSqlApplication.list = res.objects
					this.waitSqlApplication.totalPage = res.total_pages
					this.waitSqlApplication.currentPage = res.page
				},
				() => {
					this.waitSqlApplication.loading = false
				}
			)
		},
		waitSqlApplicationChangePage(page) {
			this.sqlWaitApplication(page)
		},
		sqlApprovedApplication(page) {
			const params = {
				results_per_page: 10,
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_SQL_APPROVED_APPLICATION, params).then(
				(res) => {
					this.approvedSqlApplication.loading = false
					this.approvedSqlApplication.list = res.objects
					this.approvedSqlApplication.totalPage = res.total_pages
					this.approvedSqlApplication.currentPage = res.page
				},
				() => {
					this.approvedSqlApplication.loading = false
				}
			)
		},
		approvedSqlApplicationChangePage(page) {
			this.sqlApprovedApplication(page)
		},
		getSafeModeApplication() {
			const params = {
				results_per_page: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_SAFE_APPLICATION, params).then((res) => {
				console.log('safe_', res)
				if (!Object.isEmpty(res)) {
					this.safeApplyList.projectList = Object.keys(res)
					this.safeApplyList.resourceList = res
					console.log('safeApplyList', this.safeApplyList.projectList, this.safeApplyList.resourceList, this.initInfo)
					if (this.initInfo.projectResourceId && this.initInfo.projectName) {
						this.safeApplyList.projectList.forEach((item) => {
							if (item === this.initInfo.projectName) {
								this.safe.project = this.initInfo.projectName
								res[this.initInfo.projectName].forEach((_item, index) => {
									if (_item.project_resource.id === parseInt(this.initInfo.projectResourceId)) {
										this.safe.resource = _item
										this.safe.resource_id = this.safe.resource.resource.id
										this.safe.resourceIndex = index
									}
								})
								console.log('this sade', this.safe)
							}
						})
					} else {
						this.safe.project = this.safeApplyList.projectList[0]
						this.safe.resource = this.safeApplyList.resourceList[this.safe.project][0]
						this.safe.resource_id = this.safe.resource.resource.id
					}
				}
			})
		},
		safeChanged(_project) {
			if (this.initInfo.init) {
				this.initInfo.init = false
			} else {
				if (_project) {
					this.safe.resource = this.safeApplyList.resourceList[_project][0]
					this.safe.resource_id = this.safe.resource.resource.id
					this.safe.resourceIndex = 0
					console.log(this.safe.resource, this.safe.resource_id)
				} else {
					this.safe.resource = ''
					this.safe.resource_id = null
				}
			}
		},
		safeResourceChange(index) {
			console.log('safe--->index', index, typeof index)
			if (typeof index === 'number') {
				this.safe.resource = this.safeApplyList.resourceList[this.safe.project][index]
				this.safe.resource_id = this.safe.resource.resource.id
			}
			console.log('safechange-->', this.safe)
		},
		// 我发起的安全模式
		getMySafeModeApplication(page) {
			this.mySafeApplyList.list = []
			const params = {
				results_per_page: 10,
				page: page || 1,
				q: {
					filters: [
						{
							name: 'applicant_id',
							op: 'in',
							val: [this.getAccount.id],
						},
					],
					order_by: [
						{
							field: 'create_time',
							direction: 'desc',
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_MY_SAFE_APPLY, params).then(
				(res) => {
					this.mySafeApplyList.loading = false
					this.mySafeApplyList.list = res.objects
					this.mySafeApplyList.totalPage = res.total_pages
					this.mySafeApplyList.currentPage = res.page
				},
				() => {
					this.mySafeApplyList.loading = false
				}
			)
		},
		onMySafeChangePage(page) {
			this.getMySafeModeApplication(page)
		},
		getSafeApprovingApplication(page) {
			const params = {
				results_per_page: 10,
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_SAFE_APPROVING_APPLY, params).then((res) => {
				this.safeApprovingList.loading = false
				this.safeApprovingList.list = res.objects
				this.safeApprovingList.totalPage = res.total_pages
				this.safeApprovingList.currentPage = res.page
			})
		},
		safeApprovingChangePage(page) {
			this.getSafeApprovingApplication(page)
		},
		// 安全模式我已审批的
		getSafeApprovedApplication(page) {
			const params = {
				results_per_page: 10,
				page: page || 1,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_SAFE_APPROVED_APPLY, params).then(
				(res) => {
					this.safeApprovedList.loading = false
					this.safeApprovedList.list = res.objects
					this.safeApprovedList.totalPage = res.total_pages
					this.safeApprovedList.currentPage = res.page
				},
				() => {
					console.log('err')
					this.safeApprovedList.loading = false
				}
			)
		},
		safeApprovedChangePage(page) {
			this.getSafeApprovedApplication(page)
		},
		viewCallback() {
			// console.log(this.currentRightPanel, this.rightPanelData)
			if (this.currentRightPanel.name === 'mySqlView') {
				if (this.rightPanelData.pageType === 'mySqlApply') {
					this.sqlActiveName = 'sqlMyApply'
					this._getMySqlApplication(1)
				} else {
					this.sqlActiveName = 'sqlApproved'
					this.sqlApprovedApplication(1)
				}
			} else if (this.currentRightPanel.name === 'safeView') {
				if (this.rightPanelData.pageType === 'mySafeApply') {
					this.safeActiveName = 'safeMyApply'
					this.getMySafeModeApplication(1)
				} else {
					this.safeActiveName = 'safeApproved'
					this.getSafeApprovedApplication(1)
				}
			}
		},
		getSqlDetailInfo(id, cb) {
			const params = {
				application_id: id,
			}
			this.$store.dispatch(STORE_CONST.REVIEW.GET_MY_APPLY_DETAIL, params).then((res) => {
				cb(res)
			})
		},
		viewMySqlApply(row, event, column) {
			event.cancelBubble = true
			this.getSqlDetailInfo(row.id, (res) => {
				let data = res.objects
				data.viewType = 'my'
				data.pageType = 'mySqlApply'
				if (data.status !== 'approving') {
					data.isHideFooter = true
				} else {
					data.isHideFooter = false
				}
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'mySqlView' ? 0 : 300
				this.currentRightPanel = mySqlView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
		viewApprovingSqlApply(row, event, column) {
			event.cancelBubble = true
			this.getSqlDetailInfo(row.id, (res) => {
				let data = res.objects
				data.viewType = 'approve'
				data.isHideFooter = false
				data.pageType = 'mySqlApproving'
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'mySqlView' ? 0 : 300
				this.currentRightPanel = mySqlView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
		viewApprovedSql(row, event, column) {
			event.cancelBubble = true
			this.getSqlDetailInfo(row.id, (res) => {
				let data = res.objects
				data.viewType = 'approve'
				data.isHideFooter = true
				data.pageType = 'mySqlApproved'
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'mySqlView' ? 0 : 300
				this.currentRightPanel = mySqlView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
		getSafeDetailInfo(id, cb) {
			this.$store
				.dispatch(STORE_CONST.REVIEW.GET_SAFE_DETAIL, id)
				.then((res) => {
					cb(res)
				})
				.catch((err) => {
					console.log('err--->', err)
					if (err && err.data.code === 'NeedPrivilege') {
						this.$notify.error({
							message: this.$gettext('The approval permission for the resource has been canceled'),
						})
					}
				})
		},
		viewApprovingSafe(row, event, column) {
			event.cancelBubble = true
			this.getSafeDetailInfo(row.id, (res) => {
				let data = res
				data.viewType = 'approve'
				data.isHideFooter = false
				data.pageType = 'mySafeApproving'
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'safeView' ? 0 : 300
				this.currentRightPanel = safeView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
		viewApprovedSafe(row, event, column) {
			event.cancelBubble = true
			this.getSafeDetailInfo(row.id, (res) => {
				let data = res
				data.viewType = 'approve'
				data.isHideFooter = true
				data.pageType = 'mySafeApproved'
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'safeView' ? 0 : 300
				this.currentRightPanel = safeView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
		viewMySafeApply(row, event, column) {
			event.cancelBubble = true
			this.getSafeDetailInfo(row.id, (res) => {
				let data = res
				data.viewType = 'my'
				data.pageType = 'mySafeApply'
				if (data.app_status !== 0) {
					data.isHideFooter = true
				} else {
					data.isHideFooter = false
				}
				const time = !this.currentRightPanel || this.currentRightPanel.name === 'safeView' ? 0 : 300
				this.currentRightPanel = safeView
				this.$nextTick(() => {
					setTimeout(() => {
						this.rightPanelData = Object.clone(data)
					}, time)
				})
			})
		},
	},
	watch: {
		$route(to, from) {
			console.log('route--->change')
			this.initInfo = {}
			// this.$set(this.initInfo, 'projectResourceId', null)
			// console.log('route-->change', this.initInfo)
			if (this.$route.query.type === 'sql') {
				this.initTabName = this.$route.query.type
				// this.getProjectList()
				this.sqlWaitApplication(1)
			} else if (this.$route.query.type === 'safe') {
				this.initTabName = this.$route.query.type
				// this.getSafeModeApplication()
				this.getSafeApprovingApplication(1)
			} else {
				this.initTabName = 'sql'
				this.onTabClick({ name: 'sql' })
			}
		},
	},
	components: {
		mySqlView: mySqlView,
    safeView: safeView,
    CodemirrorEditor
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';
.approved {
	color: $available;
}
.rejected {
	color: $unavailable;
}
.failed {
	color: red;
}
.review {
	.teamTab {
		.el-tabs__nav-scroll {
			height: 40px;
			line-height: 40px;
			.el-tabs__item.is-active {
				background-color: $bgColor;
			}
		}
	}
	.reviewTab {
		background-color: #fff;
		border: 1px solid $border-color;
		.el-table__row {
			.cell {
				.limit-text {
					max-width: 100%;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
			.apply-avatar-name {
				max-width: calc(100% - 76px);
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			&:hover {
				cursor: pointer;
			}
		}
		.el-tabs__header {
			background-color: #f6f8f7;
			padding-top: 0;
		}
		.el-tabs__nav-scroll {
			.el-tabs__item.is-active {
				background-color: #f6f8f7;
				color: $highlight-color;
			}
		}
		.el-tab-pane {
			padding: 20px 0;
		}
		.apply-form {
			.el-input {
				width: 360px;
			}
			.el-textarea__inner {
				width: 360px;
			}
			.font-danger {
				color: #ff4949;
			}
		}
	}
	.apply-table {
		.el-table__row {
			font-size: $fontSize;
		}
		.el-table tr {
			height: 60px;
		}
	}
	.safe-datetime-picker {
		.el-input {
			min-width: 160px;
		}
	}
	.apply-avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		margin: 12px 5px 12px 0;
		float: left;
	}
	.apply-avatar-name {
		float: left;
		line-height: 60px;
	}
}
.review-select-box {
	min-width: 360px !important;
	.review-select {
		width: 360px;
	}
}
</style>



// WEBPACK FOOTER //
// review.vue?59402760